import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Avalie a Qualidade da ligação", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " De uma nota abaixo baseado na qualidade do áudio e vídeo que durante a sessão. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "mt-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-header" }, "Teve algum problema?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Caso teve algum problema ou deseja relatar alguma ocorrência, descreva abaixo: ", -1)

import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { appointmentRatingSchema } from "@/schemas/appointment";
import { useAppointmentRatingPendingStore } from "@/store/useAppointmentRatingPendingStore";
import { toggleModal } from "@/utils/Helper";
import { useCreateRating } from "@/composables/useRatings";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentRating',
  setup(__props) {

const { values, setFieldValue, resetForm } = useForm({
  validationSchema: toTypedSchema(appointmentRatingSchema),
  initialValues: { rating: 0, description: "" },
});

const descriptionModel = useVeeField("description");

const { mutateAsync: createRating, isPending: submitting } = useCreateRating();

function setRating(rating: number) {
  setFieldValue("rating", rating);
}

function handleFinish() {
  resetForm();
  useAppointmentRatingPendingStore().clear();
  toggleModal("appointment_rating_pending");
}

async function submitRating() {
  try {
    await createRating({
      appointment_id: parseInt(useAppointmentRatingPendingStore().pending),
      trouble: false,
      rating: values.rating as number,
      description: values.description as string,
    });
    handleFinish();
  } catch (error) {
    console.error(error);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_VotingStars = _resolveComponent("VotingStars")!
  const _component_TextAreaInput = _resolveComponent("TextAreaInput")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    id: "appointment_rating_pending",
    title: "Como foi sua sessão?",
    onModalClosed: handleFinish
  }, {
    body: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_VotingStars, {
        size: "fa-xl",
        onOnClick: _cache[0] || (_cache[0] = (rating) => setRating(rating))
      }),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createVNode(_component_TextAreaInput, { model: _unref(descriptionModel) }, null, 8, ["model"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Pular",
        onOnClick: handleFinish,
        outline: ""
      }),
      _createVNode(_component_Button, {
        label: "Enviar avaliação",
        onOnClick: submitRating,
        loading: _unref(submitting)
      }, null, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

})